// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as ClonedDiv$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/drag-and-drop/ClonedDiv.bs.js";
import * as Draggable$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/drag-and-drop/Draggable.bs.js";
import * as Droppable$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/drag-and-drop/Droppable.bs.js";
import * as ZoneClusterTabItem from "./ZoneClusterTabItem.bs.js";
import * as ModificationLegends from "../../../../../../pricing-dashboard/view/components/components/sidebars/core-pricing/pricing-modification/ModificationLegends.bs.js";
import * as ReactBeautifulDnd from "react-beautiful-dnd";
import * as CircularLoader$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../../pricing-dashboard/view/assets/PricingDashboardAssetsManager.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var move_icon = PricingDashboardAssetsManager.getImage("move-icon.svg");

function getTitleAndSubtext(t) {
  if (t >= 2) {
    return [
            "Take action on modifications",
            "When a pending modification is approved, it is accepted with the priority order assigned to it."
          ];
  } else {
    return [
            "Drag the pending modification rows to rearrange the priority order",
            "Submit the new priorities after you're done. The entire modification set along with updated priority order will be sent for approval."
          ];
  }
}

function ModifyZoneClusterTabView$HelperText(Props) {
  var user_action = Props.user_action;
  var match = getTitleAndSubtext(user_action);
  return React.createElement("p", {
              className: "c-modification-helper-text"
            }, React.createElement("b", undefined, match[0]), React.createElement("div", {
                  className: "sub-text"
                }, match[1]));
}

var HelperText = {
  getTitleAndSubtext: getTitleAndSubtext,
  make: ModifyZoneClusterTabView$HelperText
};

function reorderLst(old_lst, source_index, destination_index, setDirty, updateList) {
  var shuffled_ele = Belt_List.get(old_lst, source_index);
  if (shuffled_ele === undefined) {
    return ;
  }
  var split_lst = Belt_List.splitAt(Belt_List.keepWithIndex(old_lst, (function (param, index) {
              return source_index !== index;
            })), destination_index);
  if (split_lst === undefined) {
    return ;
  }
  var second_lst = split_lst[1];
  var first_lst = split_lst[0];
  Curry._1(updateList, (function (param) {
          return Belt_List.concatMany([
                      first_lst,
                      {
                        hd: shuffled_ele,
                        tl: /* [] */0
                      },
                      second_lst
                    ]);
        }));
  return Curry._1(setDirty, (function (param) {
                return true;
              }));
}

function onDragEnd(old_list, result, setDirty, updateList) {
  var match = result.destination;
  if (match !== undefined) {
    return reorderLst(old_list, result.source.index, match.index, setDirty, updateList);
  }
  
}

function sortByPriority(campaigns) {
  return List.sort((function (a, b) {
                return a.pending_priority - b.pending_priority | 0;
              }), campaigns);
}

function ModifyZoneClusterTabView(Props) {
  var allowedUserAction = Props.allowedUserAction;
  var filtered_campaigns = Props.filtered_campaigns;
  var mandatory_campaign = Props.mandatory_campaign;
  var selected_geo_region = Props.selected_geo_region;
  var selected_vehicle = Props.selected_vehicle;
  var updatePriority = Props.updatePriority;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var user_role = Props.user_role;
  var open_modal = Props.open_modal;
  var setUpdatedStatus = Props.setUpdatedStatus;
  var dispatch = Props.dispatch;
  var match = React.useState(function () {
        return false;
      });
  var setDirty = match[1];
  var isDirty = match[0];
  var match$1 = React.useState(function () {
        return sortByPriority(filtered_campaigns);
      });
  var updateCampaignsPriority = match$1[1];
  var campaigns = match$1[0];
  React.useEffect((function () {
          if (isDirty) {
            Curry._1(updatePriority, (function (param) {
                    return campaigns;
                  }));
          }
          
        }), [
        isDirty,
        campaigns
      ]);
  React.useEffect((function () {
          if (allowedUserAction !== 0) {
            
          } else {
            Curry._1(setDirty, (function (param) {
                    return false;
                  }));
            Curry._1(updateCampaignsPriority, (function (param) {
                    return sortByPriority(filtered_campaigns);
                  }));
          }
          
        }), [allowedUserAction]);
  var tmp;
  var exit = 0;
  var error;
  var exit$1 = 0;
  if (typeof zones === "number") {
    exit$1 = 3;
  } else {
    switch (zones.TAG | 0) {
      case /* Loading */0 :
          exit$1 = 3;
          break;
      case /* Live */1 :
          var zones$1 = zones._0;
          if (typeof clusters === "number") {
            exit = 1;
          } else {
            switch (clusters.TAG | 0) {
              case /* Loading */0 :
                  exit = 1;
                  break;
              case /* Live */1 :
                  var clusters$1 = clusters._0;
                  tmp = React.createElement(ReactBeautifulDnd.DragDropContext, {
                        onDragEnd: (function (result, param) {
                            return onDragEnd(campaigns, result, setDirty, updateCampaignsPriority);
                          }),
                        children: React.createElement(ReactBeautifulDnd.Droppable, {
                              droppableId: "droppable",
                              children: (function (provided, _snapshot) {
                                  return React.createElement(ClonedDiv$Catalyst.make, {
                                              props: Droppable$Catalyst.droppableProvidedPropsToJs(provided.droppableProps, provided.innerRef),
                                              children: Belt_List.toArray(List.mapi((function (index, campaign) {
                                                          return React.createElement(ReactBeautifulDnd.Draggable, {
                                                                      draggableId: String(campaign.priority),
                                                                      index: index,
                                                                      children: (function (provided, _snapshot, _r) {
                                                                          var showDragButton = campaign.status === /* PendingForReview */2 && allowedUserAction !== /* ChangeStatus */2 && (user_role.access_level === /* ADMIN_ACCESS */0 || user_role.access_level === /* CREATE_ACCESS */1);
                                                                          return React.createElement(ClonedDiv$Catalyst.make, {
                                                                                      props: Draggable$Catalyst.draggablePropsToJs(provided.draggableProps, provided.innerRef),
                                                                                      children: React.createElement(Row$Catalyst.make, {
                                                                                            children: null,
                                                                                            className: "c-modification-handle-wrapper"
                                                                                          }, React.createElement(ZoneClusterTabItem.make, {
                                                                                                allowedUserAction: allowedUserAction,
                                                                                                priority: index + 1 | 0,
                                                                                                mandatory_campaign: mandatory_campaign,
                                                                                                campaign: campaign,
                                                                                                selected_geo_region: selected_geo_region,
                                                                                                selected_vehicle: selected_vehicle,
                                                                                                zones: zones$1,
                                                                                                clusters: clusters$1,
                                                                                                user_role: user_role,
                                                                                                open_modal: open_modal,
                                                                                                setUpdatedStatus: setUpdatedStatus,
                                                                                                dispatch: dispatch
                                                                                              }), showDragButton ? React.createElement(ClonedDiv$Catalyst.make, {
                                                                                                  props: Draggable$Catalyst.dragHandlePropsToJs(provided.dragHandleProps),
                                                                                                  children: React.createElement("img", {
                                                                                                        src: move_icon
                                                                                                      }),
                                                                                                  key: String(campaign.pending_priority)
                                                                                                }) : null),
                                                                                      key: String(campaign.pending_priority)
                                                                                    });
                                                                        }),
                                                                      key: String(campaign.pending_priority)
                                                                    });
                                                        }), campaigns))
                                            });
                                })
                            })
                      });
                  break;
              case /* Error */2 :
                  exit$1 = 3;
                  break;
              
            }
          }
          break;
      case /* Error */2 :
          error = zones._0;
          exit = 2;
          break;
      
    }
  }
  if (exit$1 === 3) {
    if (typeof clusters === "number" || clusters.TAG !== /* Error */2) {
      exit = 1;
    } else {
      error = clusters._0;
      exit = 2;
    }
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement(CircularLoader$Catalyst.make, {});
        break;
    case 2 :
        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
              error: error
            });
        break;
    
  }
  return React.createElement("div", {
              className: "c-modify-zone-cluster-tab"
            }, React.createElement(ModifyZoneClusterTabView$HelperText, {
                  user_action: allowedUserAction
                }), React.createElement(ModificationLegends.make, {}), tmp);
}

var make = ModifyZoneClusterTabView;

export {
  move_icon ,
  HelperText ,
  reorderLst ,
  onDragEnd ,
  sortByPriority ,
  make ,
  
}
/* move_icon Not a pure module */
